module.exports = __webpack_public_path__ + "img/2021_09_dande_arashiyama_fin_web.65627765.png";